import PropTypes from 'prop-types';

export const invoiceRowPropType = PropTypes.shape({
  created: PropTypes.number.isRequired,
  amountDue: PropTypes.number.isRequired,
  paid: PropTypes.bool,
  periodStart: PropTypes.number.isRequired,
  periodEnd: PropTypes.number.isRequired
});
